import React from 'react';
import { Text } from '@chakra-ui/react';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';
import { shippingGraceApplies, SHIPPING_GRACE_DAYS } from '@foodfluence/shared';

/**
 * "You have the product, start submitting" — shared by the shipped-product confirmation on the
 * collab detail page and by retail's own redeem, which asks the same question of a creator who
 * bought the product themselves. Exported so the two cannot drift apart.
 */
export const ORDER_RECEIVED_COPY = {
  title: 'Have you received your product?',
  body: "Confirming moves this collab to content submission. You won't be able to undo it.",
  confirmLabel: "Yes, I've received it",
};

/** Ship-to-home "I received my product" — this one starts the content deadline, it doesn't advance the collab. */
export const PRODUCT_RECEIVED_COPY = {
  title: 'Have you received your product?',
  body: "Confirming starts your content deadline. You won't be able to undo it.",
  confirmLabel: "Yes, I've received it",
};

/** Shown while no ship-to-home clock has started — the "I received my product" action starts it. */
export const shipToHomeWaitingText = (days?: number): string =>
  `Confirm receipt to start your ${days ?? 14}-day content deadline` +
  (shippingGraceApplies('shipToHome', days) ? `. It starts on its own ${SHIPPING_GRACE_DAYS} days after shipping.` : '');

interface ConfirmActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** Defaults keep the original "already visited" copy for in-store collabs. */
  title?: string;
  body?: string;
  confirmLabel?: string;
  /** Disables both buttons and shows a spinner on confirm while the request runs. */
  isLoading?: boolean;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Visit',
  body = "By confirming that you've already visited, you'll be able to submit your content. Are you sure you want to continue?",
  confirmLabel = 'Confirm',
  isLoading = false,
}) => {
  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      cancelLabel="Cancel"
      isCancelDisabled={isLoading}
      primary={{ label: confirmLabel, onClick: onConfirm, isLoading }}
    >
      <Text color={ff.text2}>{body}</Text>
    </ModalShell>
  );
};

export default ConfirmActionModal;
